import has from 'lodash/has';

import constants from '@/constants';

export default {
  methods: {
    getTimePairClockingTypeIndicators(timePair) {
      const indicators = [];
      if (timePair.clockOut == null) {
        const icon = has(timePair, 'pairType') ? 'emoji_food_beverage' : 'alarm';
        const tooltip = has(timePair, 'pairType') ? this.$t('indicators.currentlyAway')
          : this.$t('indicators.currentlyClockedIn');
        indicators.push(this.getIndicatorObject(
          'clock-in', icon, `${constants.AppColors.SUCCESS} darken-3`, tooltip,
        ));
      } else {
        if (timePair.isManualPair) {
          indicators.push(this.getIndicatorObject(
            'manual', 'note_add', constants.AppColors.WARN, this.$t('indicators.manualAddition'),
          ));
        }

        if (timePair.isCorrection && !timePair.deletedDate) {
          indicators.push(this.getIndicatorObject(
            'correction', 'edit', constants.AppColors.WARN, this.$t('indicators.containsCorrections'),
          ));
        }

        if ((timePair.hasTimeZoneDiscrepancy || timePair.hasShiftTimeZoneDiscrepancy) && timePair.clockOut) {
          indicators.push(this.getIndicatorObject(
            'time_zone_discrepancy',
            'public',
            constants.AppColors.WARN,
            this.$t('indicators.shiftInDifferentTimeZone'),
          ));
        }
      }
      switch (timePair.pairType) {
        case constants.WorkSchedule.SegmentType.BREAK:
        case constants.WorkSchedule.SegmentType.OT_BREAK:
          indicators.push(this.getIndicatorObject(
            'shift_breaks', 'emoji_food_beverage', constants.AppColors.PRIMARY,
            this.$t('indicators.isBreak'),
          ));
          break;
        case constants.WorkSchedule.SegmentType.OVERTIME:
        case constants.WorkSchedule.SegmentType.FIXED_OVERTIME:
        case constants.WorkSchedule.SegmentType.EARLY_LOGIN:
        case constants.WorkSchedule.SegmentType.PRE_SHIFT_OT:
          indicators.push(this.getIndicatorObject(
            'shift_overtime', 'alarm', constants.AppColors.PRIMARY, this.$t('indicators.containsOvertime'),
          ));
          break;
        default:
      }
      return indicators;
    },

    getIndicatorObject(id, icon, color, tooltip) {
      return {
        id, icon, color, tooltip,
      };
    },

  },
};
